export default "__VITE_ASSET__BNWf$Sa7__"